// extracted by mini-css-extract-plugin
module.exports =  {"attributes-wrapper":"TtUqv3k","attributesWrapper":"TtUqv3k"};